import classNames from 'classnames';

import type { TpCardPlanChildrenProps } from '@features/Paywall/widgets/subscription-card/types';
import { useCurrentPrice } from './useCurrentPrice';

import styles from './current-price.module.scss';

type TpCurrentPriceProps = TpCardPlanChildrenProps & {
  className?: string;
  classNamePerTerm?: string;
  onlyFullPrice?: boolean;
};

export const CurrentPrice = (props: TpCurrentPriceProps) => {
  const { plan, checked, className, classNamePerTerm, onlyFullPrice } = props;

  const {
    displayPrice,
    formattedPrice,
    currency,
    isLongCurrencies,
    priceDigit,
  } = useCurrentPrice({
    plan,
    onlyFullPrice,
  });

  return (
    <div
      className={classNames({
        [styles.currentPriceChecked]: checked,
        [styles.currentPriceIsLongCurrencies]: isLongCurrencies,
      })}
    >
      <h4 className={classNames(styles.currentPrice, className)}>
        <span>{currency}</span>
        <span>{priceDigit}</span>
        <div style={{ margin: 'auto 0' }}>
          <span>{formattedPrice}</span>
          {!isLongCurrencies && (
            <p className={classNames(styles.perTerm, classNamePerTerm)}>
              {displayPrice?.split(' ')[0]} {` `}
              <span className={styles.perPeriod}>
                {displayPrice?.split(' ')[1]}
              </span>
            </p>
          )}
        </div>
      </h4>
      {isLongCurrencies && (
        <p className={classNames(styles.perTerm, classNamePerTerm)}>
          {displayPrice}
        </p>
      )}
    </div>
  );
};
